import { render, staticRenderFns } from "./TitleLogo.vue?vue&type=template&id=188d584a&scoped=true&"
import script from "./TitleLogo.vue?vue&type=script&lang=js&"
export * from "./TitleLogo.vue?vue&type=script&lang=js&"
import style0 from "./TitleLogo.vue?vue&type=style&index=0&id=188d584a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188d584a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VRow})
